import React from 'react'
import { Link } from 'react-router-dom'
import { 
  Button,
  Divider
} from 'semantic-ui-react'

import { 
  FileCont } from './styled'

export const FileRow = (props) => {

  return (
    <FileCont>
      <div className='titleFile'>{`${props.title||''} : `}</div>
      <div className='fileItem'>
        {
          props.url.length!==0?
          props.url.map((item)=>{
            // return <Button type='button' content={<div className='fileName'>{item.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.open(item.urlPath,"_blank"))}/>
            return <Button type='button' content={<div className='fileName'>{item.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.location.href = item.urlPath)}/>
          })
          :
          <div className='noFile'>There is no attachment.</div>
        }
        <Divider/>
      </div>
    </FileCont>
  )
}